import { graphql } from '../../../graphql/generated';

export const CREATE_INSURANCE_MUTATION = graphql(`
  mutation CreateInsurance($input: InsuranceInput!) {
    createInsurance(input: $input) {
      id
    }
  }
`);
